module.exports = __webpack_public_path__ + "static/media/uni-green.638d4e7c.svg";